import { Outlet, Link } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

export default function DashboardLayout() {
  const { logout } = useContext(AuthContext);
  return (
    <div className="vh-100 d-flex flex-column">

      {/* Main content */}
      <div className="flex-grow-1 p-4">
        <Outlet />
      </div>
    </div>
  );
}
